import React, { useEffect, useState } from "react";
import axios from "axios";

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    const fetchPopups = async () => {
      try {
        const apiUrl = process.env.REACT_APP_SAFKAR_API_URL;
        const response = await axios.get(`${apiUrl}/popup/list?status=true&limit=100`);

        if (response.data && response.data.data && response.data.data.popups) {
          const popups = response.data.data.popups;
          const currentDate = new Date();

          const activePopup = popups.find((popup) => {
            if (!popup.status) return false;
            const startDate = new Date(popup.startDate);
            const endDate = new Date(popup.endDate);
            return currentDate >= startDate && currentDate <= endDate;
          });

          if (activePopup) {
            setPopupData(activePopup);
            setShowPopup(true);
          }
        }
      } catch (error) {
        console.error("Error fetching popups:", error);
      }
    };

    fetchPopups();
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  if (!showPopup || !popupData) return null;

  const fileUrl = process.env.REACT_APP_SAFKAR_API_FILE_URL;
  const imageUrl = `${fileUrl}${popupData.image}`;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeButton} onClick={closePopup}>
          &times;
        </button>
        <div style={styles.content}>
          <img
            src={imageUrl}
            alt={popupData.translations?.tr?.title || "Popup"}
            style={styles.image}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999999,
  },
  modal: {
    position: "relative",
    backgroundColor: "transparent",
    padding: "0",
    borderRadius: "8px",
    maxWidth: "90%",
    maxHeight: "90%",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  closeButton: {
    position: "absolute",
    top: "-15px",
    right: "-15px",
    background: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    fontSize: "20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    zIndex: 999999999,
  },
  content: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    borderRadius: "8px",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
    display: "block",
  },
};

export default Popup;
